import { NotificationSeverity } from '@fsp/types';

export const getSeverityColor = (severity: NotificationSeverity) => {
  switch (severity) {
    case NotificationSeverity.ERROR:
      return 'error';
    case NotificationSeverity.WARNING:
      return 'warning';
    case NotificationSeverity.SUCCESS:
      return 'success';
    case NotificationSeverity.INFO:
    default:
      return 'primary';
  }
};

export default getSeverityColor;
